import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { noop } from 'lodash';
import { profileSelectors } from 'store/profile';
import BackButton from 'components/BackButton';
import ProfileItem from 'pages/Profile/ProfileItem';
import { StyledTitleBlock, StyledTitle, StyledParentalItemsWrapper } from './StyledComponents';

const SECTION_NAME = 'PARENTAL_LOCK';

const ParentalControlPage: React.FC = () => {
  const history = useHistory();
  const items = useSelector(profileSelectors.selectParentalControlItems);

  const onEnter = (index) => {
    const item = items[index];

    history.push(`parental-control/${item.id}`);
  };

  return (
    <>
      <BackButton onEnter={history.goBack} />
      <div>
        <StyledTitleBlock>
          <StyledTitle left>Parental control</StyledTitle>
        </StyledTitleBlock>
        <StyledParentalItemsWrapper defaultSection id="parental" sectionName={SECTION_NAME}>
          {items.map((item, index) => (
            <ProfileItem
              onEnter={onEnter}
              onFocus={noop}
              index={index}
              item={item}
              key={item.id}
              id={item.id}
            />
          ))}
        </StyledParentalItemsWrapper>
      </div>
    </>
  );
};

export default ParentalControlPage;
